import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom'; // <--- import `withRouter`. We will use this in the bottom of our file.
import { Col, notification, Row, Spin } from 'antd';
import { useGlobalState } from './GlobalState';
import '../../lake_manager/assets/css/summary.css';
import Slider from 'react-slick';
import ArrowLeft from '../../../assets/images/lake_manager/LeftArrow.png';
import ArrowRight from '../../../assets/images/lake_manager/RightArrow.png';
import axios from 'axios';
import MarkdownContent from '../../../../common/MarkdownContent';

const admin_url = process.env.REACT_APP_ADMIN_PATH;

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <img
      className={className}
      onClick={onClick}
      src={ArrowRight}
      alt={'right arrow'}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <img
      className={className}
      onClick={onClick}
      src={ArrowLeft}
      alt={'left arrow'}
    />
  );
}

function Summary(props) {
  const [loading, setLoading] = useState(true);
  const [lakeId] = useGlobalState('lakeId');

  const [lakeName] = useGlobalState('lakeName');

  const [summary, setSummary] = useGlobalState('summary');

  const [, setLakeMainImage] = useGlobalState('lakeMainImage');
  const [, setLakeImages] = useGlobalState('lakeImages');
  const [, setRodHours] = useGlobalState('rodHours');
  const [, setSwimTypeId] = useGlobalState('swimTypeId');
  const [, setLakeUserInput] = useGlobalState('lakeUserInput');
  const [, setMaxRod] = useGlobalState('maxRod');
  const [, setLimitSimultaneous] = useGlobalState('limitSimultaneous');
  const [, setNonAnglingGuest] = useGlobalState('nonAnglingGuest');
  const [, setUserConcessionPricing] = useGlobalState('userConcessionPricing');
  const [, setUserPricingInfo] = useGlobalState('userPricingInfo');
  const [, setRecurringValue] = useGlobalState('recurringValue');
  const [, setRecurringPricing] = useGlobalState('recurringPricing');
  const [, setNewRecurringPricing] = useGlobalState('newRecurringPricing');
  const [, setSwimTypeDetail] = useGlobalState('swimTypeDetail');
  const [, Setchecked] = useGlobalState('doubleCheck');
  const [, setselectedSwimType] = useGlobalState('selectedSwimType');
  const [, setselectedSwimSize] = useGlobalState('selectedSwimSize');
  const [, setIsChecked] = useGlobalState('concessionChecked');

  const settings = {
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const getSummary = () => {
    const data = { lake_id: lakeId };

    const config = {
      headers: {
        // 'Accept': 'application/json',
        // 'content-type': 'multipart/form-data'
      },
      withCredentials: true,
      crossDomain: true,
      baseURL: `${process.env.REACT_APP_AXIOS_URL}fishery`,
      'Access-Control-Allow-Origin': '*',
      sameSite: null,
      secure: false,
      params: data,
    };

    axios
      .get('/lake/summary', config)
      .then((res) => {
        if (res.status === 200) {
          let data = res.data.result;
          console.log(data);

          setSummary(data);
          console.log(summary);
          setLakeMainImage(data.lake_main_image);
          setLakeImages(data.lake_secondary_images);
          // setUserInputSwims(data.swims);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          if (err.response.status === 401) {
            props.history.push('/admin/login');
          }
        }
      });
  };

  const onFinish = () => {
    notification.success({
      message: <div className='gSemiBold'>Success!</div>,
      style: { border: '1px #2CB972 solid' },
      placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
      className: 'gRegular br10',
      description: 'Congratulations! Your lake has been set up successfully!',
    });
    setSwimTypeId('');
    setRodHours([
      { name: 12, isChecked: true, 1: '', 2: '', 3: '' },
      { name: 24, isChecked: true, 1: '', 2: '', 3: '' },
      { name: 36, isChecked: true, 1: '', 2: '', 3: '' },
      { name: 48, isChecked: true, 1: '', 2: '', 3: '' },
      { name: 60, isChecked: true, 1: '', 2: '', 3: '' },
      { name: 72, isChecked: true, 1: '', 2: '', 3: '' },
    ]);
    setLakeUserInput(null);
    setMaxRod(3);
    setLimitSimultaneous('no');
    setNonAnglingGuest('no');
    setUserPricingInfo(null);
    setUserConcessionPricing(null);
    setRecurringValue(0);
    setRecurringPricing('');
    setNewRecurringPricing('');
    setSwimTypeDetail('');
    Setchecked([{ value: false }]);
    setIsChecked(false);
    setselectedSwimSize([{ value: '' }]);
    setselectedSwimType([{ value: '' }]);
  };

  useEffect(() => {
    if (lakeName) {
      getSummary();
    } else {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description: 'Please start over',
      });
      props.history.push(`${admin_url}/lake_manager`);
    }
  }, []);

  return (
    <div className='lake-manager-content'>
      {!loading && summary ? (
        <Row className='lm-steps' align='middle' justify='center'>
          <Col id='lake-summary' span={24}>
            <h1 className='gBold mg-bottom-5'>
              Let’s check everything you’ve entered.
            </h1>
            <p className='fs-20 gLight'>
              Once you're happy with all the info below, just click 'finish' to
              add your lake to swimbooker.
            </p>

            <Row>
              <Col span={24}>
                <Row>
                  <Col
                    id={'summary-left'}
                    xs={24}
                    md={14}
                    xl={12}
                    className='pd-top-30'
                  >
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>Lake Name: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.lake_name ? summary.lake_name : 'test'}
                        </span>
                      </Col>
                    </Row>
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>Lake Type: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.service_type ? summary.service_type : 'test'}
                        </span>
                      </Col>
                    </Row>
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>Angling Type: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.lake_type ? summary.lake_type : 'test'}
                        </span>
                      </Col>
                    </Row>
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>Lake Access: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.access_type ? summary.access_type : 'test'}
                        </span>
                      </Col>
                    </Row>
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>No. Of Swims: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.total_swims ? summary.total_swims : 'test'}
                        </span>
                      </Col>
                    </Row>
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>Max. Sim. Bookings: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.max_sim_booking
                            ? summary.max_sim_booking
                            : 'test'}
                        </span>
                      </Col>
                    </Row>
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'> Swim Types: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.swim_types
                            ? summary.swim_types.map((s, i) => {
                                return i === 0
                                  ? s.name
                                  : i === summary.swim_types.length - 1
                                    ? ' & ' + s.name
                                    : ', ' + s.name;
                              })
                            : 'test'}
                        </span>
                      </Col>
                    </Row>
                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>Max. Rods. Per Angler: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.max_rod_per_angler
                            ? summary.max_rod_per_angler
                            : 'test'}
                        </span>
                      </Col>
                    </Row>

                    <Row className='fs-20 mg-bottom-5'>
                      <Col span={12}>
                        <span className='gBold'>Species: </span>{' '}
                      </Col>
                      <Col span={11}>
                        <span className='gLight'>
                          {summary.species
                            ? summary.species.map((species, i) => {
                                return i === 0
                                  ? species
                                  : i === summary.species.length - 1
                                    ? ' & ' + species
                                    : ', ' + species;
                              })
                            : 'test'}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} md={10} xl={12} className='mg-bottom-20'>
                    <h2 className='gBold mg-bottom-0'>Description:</h2>
                    <p className='gLight lake-summary-desc br10'>
                      <MarkdownContent
                        className='lake-manager-lake-info-markdown-display'
                        name='description'
                        content={
                          summary.description ? summary.description : 'test'
                        }
                      />
                    </p>
                    <h2 className='gBold mg-bottom-0'>Rules:</h2>
                    <p className='gLight lake-summary-desc br10'>
                      <MarkdownContent
                        className='lake-manager-lake-info-markdown-display '
                        name='description'
                        content={summary.rules ? summary.rules : 'test'}
                      />
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={8} sm={6} md={4}>
                    <p id='summary-imagery-title' className='gSemiBold'>
                      Imagery:
                    </p>
                  </Col>
                  <Col id='summary-slider' xs={24} md={19}>
                    <Slider {...settings}>
                      {summary.images.map((data, index) => (
                        <Col key={index}>
                          <img alt={index} src={data} />
                        </Col>
                      ))}
                    </Slider>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className='mg-top-50 '>
              <div className={'lm-buttons-container'}>
                <div className='lm-back-btn '>
                  <Link
                    className='white gBold fs-17 br5 bg-light-grey'
                    to={`${admin_url}/lake_manager/swim_images`}
                  >
                    <span>Back</span>
                  </Link>
                </div>
                <div className='lm-next-btn '>
                  <Link
                    className='white gBold fs-17 br5 light-green-bg'
                    to={`${admin_url}/lake_manager/`}
                  >
                    <span onClick={onFinish}>Finish</span>
                  </Link>
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      ) : loading && !summary ? (
        <div id='general-admin-page-loading'>
          <Spin />{' '}
        </div>
      ) : (
        <p>Error fetching summary data.</p>
      )}
    </div>
  );
}

export default withRouter(Summary);
